var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaRulerHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3411_2292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3411_2292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0013 12.5C2.63464 12.5 2.32075 12.3694 2.05964 12.1083C1.79852 11.8472 1.66797 11.5333 1.66797 11.1667V5.83333C1.66797 5.46667 1.79852 5.15278 2.05964 4.89167C2.32075 4.63056 2.63464 4.5 3.0013 4.5H13.668C14.0346 4.5 14.3485 4.63056 14.6096 4.89167C14.8707 5.15278 15.0013 5.46667 15.0013 5.83333V11.1667C15.0013 11.5333 14.8707 11.8472 14.6096 12.1083C14.3485 12.3694 14.0346 12.5 13.668 12.5H3.0013ZM3.0013 11.1667H13.668V5.83333H11.668V8.5H10.3346V5.83333H9.0013V8.5H7.66797V5.83333H6.33464V8.5H5.0013V5.83333H3.0013V11.1667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaRulerHorizontal);
export default __webpack_public_path__ + "static/media/FaRulerHorizontal.c15ccc36aaeac245e1f1a2b1f1b98767.svg";
export { ForwardRef as ReactComponent };